import React from 'react';

import { Link } from 'react-router-dom';

import logo2 from '../../images/analyticsLogo.png';
import ScreenReaderMsg from './ScreenReaderMsg';

const Header = (props) => {
  const { plainLogo } = props;
  return (
    <header className="headerContainer app-header text-center">
      {plainLogo ? (
        <img src={logo2} className="App-logo" alt="Liaison Analytics Logo" />
      ) : (
        <Link to="/" aria-label="Liaison Analytics">
          <img src={logo2} className="App-logo" alt="Liaison Analytics Logo" />
        </Link>
      )}
      <ScreenReaderMsg />
    </header>
  );
};

export default Header;
